var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluevideoon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1801 14.75H5.31988C1.88976 14.75 0.75 13.0042 0.75 11.25V4.25C0.75 1.62292 1.88976 0.75 5.31988 0.75H12.1801C15.6102 0.75 16.75 1.62292 16.75 4.25V11.25C16.75 13.8771 15.5994 14.75 12.1801 14.75Z",
    stroke: "#005386",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6426 12.3336L17 10.5816V4.9122L19.6426 3.16019C20.9354 2.30664 22 2.82775 22 4.3282V11.1745C22 12.675 20.9354 13.1961 19.6426 12.3336Z",
    stroke: "#005386",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 6.75C13.0784 6.75 13.75 6.07843 13.75 5.25C13.75 4.42157 13.0784 3.75 12.25 3.75C11.4216 3.75 10.75 4.42157 10.75 5.25C10.75 6.07843 11.4216 6.75 12.25 6.75Z",
    stroke: "#005386",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluevideoon);
export default __webpack_public_path__ + "static/media/bluevideoon.e2c0ece00490e0f66519bca666f0c714.svg";
export { ForwardRef as ReactComponent };